<h1 *ngIf="canManageAuxData" mat-dialog-title>{{data.baseTable ? editText : newText}}</h1>
<div mat-dialog-content>
  <app-personauxdata-editor #personAuxEditor [baseTable]="data.baseTable" [tableNumber]="data.tableNumber"></app-personauxdata-editor>
</div>
<div mat-dialog-actions>
  <button *ngIf="canManageAuxData" mat-raised-button (click)="personAuxEditor.save();"  [disabled]="!personAuxEditor.form.dirty" color="primary"> {{'common.Save' | translate}}</button>
  <button *ngIf="canManageAuxData" mat-raised-button (click)="cancel()" color="warn"> {{'common.Cancel' | translate}}</button>
</div>
